import BlogInfiniteScrollContainer from "../../../../components/pages/blog/blogPage/BlogInfiniteScroll";

const BlogInfiniteScroll = () => {
  return <BlogInfiniteScrollContainer />;
};

export default BlogInfiniteScroll;
